export const CONTACT = {
  phoneDisplay: "+91 99899 66338",
  phoneHref: "tel:+919989966338",
  whatsapp:
    "https://wa.me/919989966338?text=Hello%20Sai%20Mohan%20Constructions%2C%20I%27d%20like%20to%20discuss%20a%20project.",
  email: "saimohanconstructions@gmail.com",
  emailHref: "mailto:saimohanconstructions@gmail.com",
  instagram: "https://instagram.com/saimohanconstructions",
  address:
    "Flat No. 501, Sri Sai Padmasree, Plot No. 23, Greenlands Colony, Gachibowli X Roads, Hyderabad - 500 032",
};

export const TAGLINE = "Civil Contractors, Builders & Realtors";
export const PROPRIETOR = "J. Ramanjaneyulu";

export const HERO_IMAGE = "/projects/p5.jpg";

export const BLUEPRINT_IMAGE =
  "https://images.pexels.com/photos/4458205/pexels-photo-4458205.jpeg?auto=compress&cs=tinysrgb&w=1400";

export const STATS = [
  { value: 18, suffix: "+", decimals: 0, label: "Years of Building", spec: "SPEC / 01" },
  { value: 120, suffix: "+", decimals: 0, label: "Projects Delivered", spec: "SPEC / 02" },
  { value: 2.5, suffix: " M+", decimals: 1, label: "Sq.Ft. Developed", spec: "SPEC / 03" },
  { value: 350, suffix: "+", decimals: 0, label: "Happy Families", spec: "SPEC / 04" },
];

export const CHAPTERS = [
  {
    num: "01",
    title: "Precision Engineering",
    body: "Every drawing measured twice, every slab cast once. We engineer to millimetre tolerances so your structure performs exactly as designed — no shortcuts, no surprises.",
  },
  {
    num: "02",
    title: "Structural Strength",
    body: "Fe550D steel, M25+ grade concrete and soil-tested foundations. We over-spec where it matters most, so your building outlives its promise.",
  },
  {
    num: "03",
    title: "Cost Intelligence",
    body: "Honest BOQs, bulk procurement and zero hidden escalations. Value engineering at every stage — because strength should never cost a fortune.",
  },
  {
    num: "04",
    title: "On-Time Handover",
    body: "Weekly progress reports, photo documentation and milestone-based billing. 98% of our projects hand over on or before schedule.",
  },
];

export const SERVICES = [
  {
    icon: "Home",
    title: "Residential Construction",
    body: "Independent houses, villas and apartment blocks — built to last generations, priced to make sense.",
  },
  {
    icon: "Building2",
    title: "Commercial & Industrial",
    body: "Office spaces, retail complexes, warehouses and industrial sheds engineered for heavy duty.",
  },
  {
    icon: "DraftingCompass",
    title: "Design & Approvals",
    body: "Architectural planning, structural design and complete GHMC / HMDA approval handling.",
  },
  {
    icon: "KeyRound",
    title: "Turnkey Projects",
    body: "From foundation to finish — one contract, one team, single-point responsibility until handover.",
  },
  {
    icon: "Hammer",
    title: "Renovation & Retrofitting",
    body: "Structural strengthening, remodelling and restoration that extends the life of old buildings.",
  },
  {
    icon: "Calculator",
    title: "Estimation & PMC",
    body: "Detailed BOQs, rate analysis and project management consultancy that keeps budgets honest.",
  },
];

export const PROJECTS = [
  {
    name: "Valluramma Nilayam",
    type: "Independent 2 Floor · 2 BHK Apartments",
    location: "NRI Anand Nagar Colony, Beeramguda, Hyderabad",
    tag: "Completed",
    span: "wide",
    image: "/projects/p11.jpg",
  },
  {
    name: "Valluramma Nilayam",
    type: "Independent 2 Floor · 2 BHK Apartments",
    location: "NRI Anand Nagar Colony, Beeramguda, Hyderabad",
    tag: "Completed",
    span: "narrow",
    image: "/projects/p5.jpg",
  },
  {
    name: "Sri Sai Padmasree",
    type: "Residential Apartments",
    location: "Greenlands Colony, Gachibowli",
    tag: "Completed",
    span: "third",
    image: "/projects/p4.jpg",
  },
  {
    name: "Multi-Storey Apartments",
    type: "Apartment Elevation",
    location: "Hyderabad",
    tag: "Completed",
    span: "third",
    image: "/projects/p3.jpg",
  },
  {
    name: "Classic Arch Apartments",
    type: "Apartment Elevation",
    location: "Hyderabad",
    tag: "Completed",
    span: "third",
    image: "/projects/p2.jpg",
  },
  {
    name: "Contemporary Duplex House",
    type: "Duplex Elevation",
    location: "Hyderabad",
    tag: "Completed",
    span: "half",
    image: "/projects/p1.jpg",
  },
  {
    name: "Garden Court Duplex",
    type: "Duplex Elevation",
    location: "Hyderabad",
    tag: "Completed",
    span: "half",
    image: "/projects/p6.jpg",
  },
  {
    name: "Precision Elevation Study",
    type: "Working Drawing with Dimensions",
    location: "Hyderabad",
    tag: "Completed",
    span: "third",
    image: "/projects/p7.jpg",
  },
  {
    name: "Terracotta Apartments",
    type: "Apartment Elevation",
    location: "Hyderabad",
    tag: "Completed",
    span: "third",
    image: "/projects/p8.jpg",
  },
  {
    name: "Independent House",
    type: "Completed Residence",
    location: "Hyderabad",
    tag: "Completed",
    span: "third",
    image: "/projects/p9.jpg",
  },
  {
    name: "Woodframe Residence",
    type: "Duplex Elevation",
    location: "Hyderabad",
    tag: "Completed",
    span: "third",
    image: "/projects/p10.jpg",
  },
];

export const ONGOING_PROJECTS = [
  {
    name: "Annapurna Residency",
    type: "3 BHK Apartments",
    units: "4 Floors · 1 Flat per Floor",
    address: "Chandanagar, 150 m from Mumbai Highway, Hyderabad",
    progress: 80,
    handover: "Within 3 months of purchase",
    specs: [
      { label: "Flat Size", value: "1,445 sq.ft · 3 BHK" },
      { label: "Common Area", value: "200 sq.ft per floor" },
      { label: "Floors", value: "4 — one 3 BHK each" },
      { label: "Setbacks", value: "Appropriate setbacks provided" },
    ],
  },
];

export const PROPERTIES_FOR_SALE = [
  {
    title: "Open Plot",
    size: "189 sq.yds",
    facing: "East Facing",
    price: "₹80,000 per sq.yd (Negotiable)",
    total: "₹1,51,20,000 total (189 × ₹80,000)",
    address: "Sai Bhavani Colony, Ameenpur — 300 m from Lingampally",
    landmark: "Near Sri Devi & Sri Latha Theatres",
  },
];
